import { Action, combineReducers } from '@ngrx/store';

import * as fromAdvancedFilters from './advanced-filters.reducer';

export const featureKey = 'assign.selectors.ts';

export interface AssignState {
  [fromAdvancedFilters.featureKey]: fromAdvancedFilters.State;
}

export function reducers(state: AssignState, action: Action): AssignState {
  return combineReducers({
    [fromAdvancedFilters.featureKey]: fromAdvancedFilters.reducer,
  })(state, action);
}
